import React from "react";
import { StyledMenu, StyledMenuItem } from "./Styles";
import { useDocumentOptions, useFolderOptions } from "../../../hooks/useMenuOptions";
import { ExamOverviewRow } from "../../../interfaces/examInterfaces";

export interface OptionProps {
  title: string;
  icon: JSX.Element;
  action?: () => void;
  activeWhenNoValidLicense?: Boolean;
}

interface BasicMenuProps {
  anchorEl: HTMLElement | null;
  open: boolean;
  handleCloseMenu: (event: React.MouseEvent | React.TouchEvent) => void;
  rowSelected: ExamOverviewRow | null;
  openItem: (examId: string) => void;
  accessExpired?: Boolean | undefined;
}

export default function BasicMenu({
  anchorEl,
  open,
  handleCloseMenu,
  rowSelected,
  openItem: openExam,
  accessExpired,
}: BasicMenuProps) {
  const documentOptions = useDocumentOptions({ openExam });
  const folderOptions = useFolderOptions();
  const options = rowSelected?.isDirectory ? folderOptions : documentOptions;

  return (
    <StyledMenu
      id="basic-menu"
      anchorEl={anchorEl}
      open={open}
      onClose={(event) => handleCloseMenu(event as React.MouseEvent | React.TouchEvent)}
      MenuListProps={{
        "aria-labelledby": "basic-button",
      }}
    >
      <Options options={options} handleCloseMenu={handleCloseMenu} accessExpired={accessExpired} />
    </StyledMenu>
  );
}

function Options({
  options,
  handleCloseMenu,
  accessExpired,
}: {
  options: OptionProps[];
  handleCloseMenu: (event: React.MouseEvent | React.TouchEvent) => void;
  accessExpired: Boolean | undefined;
}) {
  return (
    <>
      {options.map((option, index) => (
        <StyledMenuItem
          onClick={(event) => {
            if (!accessExpired) {
              option.action!();
            } else if (accessExpired && option.activeWhenNoValidLicense) {
              option.action!();
            }
            handleCloseMenu(event);
          }}
          key={index}
          sx={{
            opacity: !accessExpired || option.activeWhenNoValidLicense ? 1 : 0.5,
          }}
        >
          {option.icon}
          {option.title}
        </StyledMenuItem>
      ))}
    </>
  );
}
